import { List, Map, Record } from 'immutable';

export default Record({
    amount_due: null,
    attempted: null,
    billing: null,
    closed: null,
    currency: null,
    date: null,
    description: null,
    discount: null,
    due_date: null,
    id: null,
    lines: Map({
        data: List([]),
        has_more: null,
        object: null,
        total_count: null,
        url: null,
    }),
    metadata: List([]),
    next_payment_attempt: null,
    paid: null,
    period_end: null,
    period_start: null,
    receipt_number: null,
    starting_balance: null,
    statement_description: null,
    statement_descriptor: null,
    subscription: null,
    subtotal: null,
    total: null,
});



// WEBPACK FOOTER //
// ./src/records/invoice.js